import React from 'react';

import {
  Box,
  Button,
  ButtonSize,
  ButtonVariant,
  Container,
  H2,
  IoLogoDiscord,
  IoMailSharp,
  Lead,
  PaperPlane,
  PaperPlaneVariant,
  Section,
  useBreakpoint,
} from 'react-components';
import { motion } from 'framer-motion';

import { discordLink, supportEmail } from 'shared/globals';

interface PaperPlaneSectionProps {
  title: string;
  lead: string;
}

export const PaperPlaneSection: React.FunctionComponent<PaperPlaneSectionProps> = ({
  title,
  lead,
}) => {
  const isSmUp = useBreakpoint('sm');

  return (
    <Section bg="success.success50" py={{ _: '3rem', sm: '6rem' }}>
      <Container textAlign={{ _: 'start', sm: 'center' }}>
        <Box display="flex" justifyContent="center">
          <PaperPlane
            variant={PaperPlaneVariant.DEFAULT}
            width={isSmUp ? '21rem' : 'min(17.6rem, 100%)'}
            height={isSmUp ? '21rem' : '12.5rem'}
          />
        </Box>
        <H2
          as={motion.h2}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 'all' }}
          variants={{
            visible: { opacity: 1, y: 0 },
            hidden: { opacity: 0, y: 20 },
          }}
          transition={{ type: 'spring', stiffness: 30, delay: 0 }}
          my={0}
        >
          {title}
        </H2>
        <Lead
          color="black"
          my={{ _: '1.5rem', sm: 4 }}
          as={motion.p}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 'all' }}
          variants={{
            visible: { opacity: 1, y: 0 },
            hidden: { opacity: 0, y: 20 },
          }}
          transition={{ type: 'spring', stiffness: 30, delay: 0.2 }}
        >
          {lead}
        </Lead>
        <Box
          display="flex"
          gridGap={{ _: 1, sm: '1.5rem' }}
          flexWrap="wrap"
          justifyContent={{ _: 'flex-start', sm: 'center' }}
        >
          <Button
            variant={ButtonVariant.OUTLINED}
            size={ButtonSize.LARGE}
            as="a"
            href={`mailto:${supportEmail}`}
          >
            <IoMailSharp />
            <Box as="span" ml={2}>
              Mail
            </Box>
          </Button>
          <Button
            variant={ButtonVariant.OUTLINED}
            size={ButtonSize.LARGE}
            as="a"
            href={discordLink}
          >
            <IoLogoDiscord />
            <Box as="span" ml={2}>
              Discord
            </Box>
          </Button>
        </Box>
      </Container>
    </Section>
  );
};
